import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL;

export default function QuizPage() {
  const [cfg, setCfg] = useState(null);
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [answers, setAnswers] = useState(Array(10).fill(''));
  const [status, setStatus] = useState('');

  useEffect(() => {
    fetch(`${API}/quiz/config`).then(r=>r.json()).then(setCfg).catch(()=>setCfg(null));
  }, []);

  function setAnswer(idx, val) {
    setAnswers(prev => prev.map((a, i) => i===idx ? val : a));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('');
    try {
      const res = await fetch(`${API}/quiz/submit`, {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          full_name: fullName.trim(),
          phone: phone.trim(),
          answers
        })
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.error || 'Feil ved innsending');
      setStatus(`Takk ${fullName}! Du er med i trekningen. Lykke til!`);
    } catch (e) {
      setStatus('Feil: ' + e.message);
    }
  }

  if (!cfg) return <div className="max-w-2xl mx-auto p-6">Laster…</div>;

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-[#000099] mb-4">{cfg.title}</h1>

      <form onSubmit={handleSubmit} className="space-y-4 bg-white rounded-xl p-4 shadow">
        <div className="flex gap-3">
          <input className="flex-1 border px-3 py-2 rounded"
                 placeholder="Fullt navn"
                 value={fullName} onChange={e=>setFullName(e.target.value)} required />
          <input className="w-40 border px-3 py-2 rounded"
                 placeholder="Telefon"
                 value={phone} onChange={e=>setPhone(e.target.value)} required />
        </div>

        <ol className="space-y-3 list-decimal pl-6">
          {cfg.questions.map((q, i) => (
            <li key={q.id}>
              <div className="font-medium mb-1">{q.text}</div>
              <div className="flex gap-3">
                {['A','B','C'].map((key, idx) => (
                  <label key={key} className="inline-flex items-center gap-2">
                    <input type="radio"
                           name={`q${i}`}
                           value={key}
                           checked={answers[i]===key}
                           onChange={()=>setAnswer(i, key)} required />
                    <span>{q.options[idx]}</span>
                  </label>
                ))}
              </div>
            </li>
          ))}
        </ol>

        <button className="bg-[#000099] text-white px-6 py-2 rounded hover:bg-blue-900">Send inn</button>
        {status && <div className="mt-2">{status}</div>}
      </form>
    </div>
  );
}
